import { useEffect, useState } from "react";
import { apiHandler } from "../../assets/api";
import { endpoint } from "../../assets/api/endpoint";
import { IoIosArrowDropleft } from "react-icons/io";
import { useNavigate } from "react-router-dom";

const PrivacyAndPolicy = () => {
    const [htmlContent, setHtmlContent] = useState("");
    const navigate = useNavigate();

    const fetchTermAndCondition = async () => {
        try {
            const result = await apiHandler({
                url: `${endpoint.BASE_URL_STAGING}public/images/20250705105311.html`,
                method: "GET",
                responseType: "text",
            });
            if (result && result.data) {
                setHtmlContent(result.data);
            }
        } catch (error) {
            console.error("Error fetching HTML content:", error);
        }
    };

    useEffect(() => {
        fetchTermAndCondition();
    }, []);

    const onGoToBackPage = () => {
        navigate(-1);
    }

    return (
        <div className=" bg-white">
            <button className='back-page-btn d-flex justify-content-between' style={{ cursor: 'pointer', fontSize: '16px' }} onClick={onGoToBackPage}> <IoIosArrowDropleft style={{ fontSize: '31px' }} /> <span> Back </span></button>
            <div
                dangerouslySetInnerHTML={{ __html: htmlContent }}
                className="prose max-w-none"
            />
        </div>
    );
};

export default PrivacyAndPolicy;
